<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <div class="page-header d-flex justify-content-between">
        <div>
          <h3 class="page-title">{{ $t('settings.menu_title.forms') }}</h3>
        </div>
      </div>
      <table-component
        ref="contactTable"
        :show-filter="false"
        :data="islamicFinanceForm"
        table-class="table tax-table"
        class="mb-3"
      >
        <table-column
          :sortable="true"
          :label="$t('islamic_finance.step_name')"
          show="name"
        />
        <table-column
          :sortable="true"
          :label="$t('islamic_finance.form_title')"
          show="title"
        />
        <table-column
          :label="$t('islamic_finance.form_message')"
        >
          <template slot-scope="row">
            <span>{{ $t('islamic_finance.form_message') }}</span>
            <div v-html="row.message"/>
          </template>
        </table-column>
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span>{{ $t('settings.tax_types.action') }}</span>
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <div class="dropdown-item" @click="editForm(row)">
                  <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                  {{ $t('general.edit') }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
export default {
  mixins: [validationMixin],
  data () {
    return {
      formData: {}
    }
  },
  computed: {
    ...mapGetters('islamicFinanceForm', [
      'islamicFinanceForm'
    ])
  },
  watch: {
  },
  validations: {
    formData: {}
  },
  created () {
  },
  mounted () {
    this.islamicFormData()
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('islamicFinanceForm', [
      'islamicFormData'
    ]),

    editForm (data) {
      this.openModal({
        'title': 'Edit Islamic Form',
        'componentName': 'IslamicFinanceFormModal',
        'id': data.id,
        'data': data
      })
    }
  }
}
</script>
